import { render, staticRenderFns } from "./CompSurveyComment.vue?vue&type=template&id=2fa9d4a6&"
import script from "./CompSurveyComment.vue?vue&type=script&lang=ts&"
export * from "./CompSurveyComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports